import React from 'react';
import PropTypes from 'prop-types';
import { Button, Checkbox } from 'day8-ui';
import { PiBoat } from "@react-icons/all-files/pi/PiBoat";
import {
  getSelectedFilters, isFilterSelected, onFilterSelect
} from '../../../../helpers/filter';
import { FILTERS } from '../../../../constants';
import { capitalizeFirstLetter } from '../../../../helpers/utilities';
import { useDispatch } from 'react-redux';

const Hull = props => {
  const dispatch = useDispatch();
  const hullTypes = ['catamaran', 'monohull'];
  const selectedFilterText = getSelectedFilters(props.location)[FILTERS.HULL_TYPE].map(item => capitalizeFirstLetter(item)).join(', ');
  return props.mobile ? (
    <div className={props.className}>
      <div>
        <h3 className='dui-font-body !dui-font-normal dui-tracking-normal'>Hull</h3>
        <div className={props.inline ? 'dui-flex dui-flex-wrap dui-gap-4' : ''}>
          <Checkbox
            id={FILTERS.HULL_TYPE}
            onClick={e => onFilterSelect(props.location, dispatch, props.filterAction, FILTERS.HULL_TYPE, e.target.value)}
            options={hullTypes.map(hull => ({
              label: capitalizeFirstLetter(hull),
              value: hull,
              checked: isFilterSelected(props.location, FILTERS.HULL_TYPE, hull)
            }))}
          />
        </div>
      </div>
    </div>
  ) : <Button buttonType="LINK" onClick={props.filterModalToggle} leftIcon={<PiBoat />}>{selectedFilterText || 'Hull'}</Button>;
};
Hull.propTypes = {
  location: PropTypes.object.isRequired,
  filterAction: PropTypes.func.isRequired,
  setPage: PropTypes.func,
  mobile: PropTypes.bool,
  renderFilterMenuButton: PropTypes.bool,
  filterModalToggle: PropTypes.bool,
  className: PropTypes.string
};
export default Hull;
